







































































































































































































































































import {
  MfaManageStep,
  MfaStatusEnum
} from "../types";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import Widget from "@/shared/components/Widget.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import {
  Component,
  Vue,
  Watch
} from "@/shared/vuepack";
import QrcodeVue from "qrcode.vue";
import MfaWidget from "@/shared/components/MfaWidget.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useMfaStore } from "@/shared/store/mfa";

@Component({
  components: {
    MfaWidget,
    Input,
    Button,
    Widget,
    QrcodeVue,
    RadioButton
  }
})
export default class MfaSettings extends Vue {
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  mfaStore = useMfaStore();
  portalCustomizationStore = usePortalCustomizationStore();

  isSubmitting = false;
  password = "";
  token = "";
  formPhoneNumber = "";
  phoneVerificationCode = "";
  selectedMfaType: MfaStatusEnum = null;
  startingMfaType: MfaStatusEnum = null;
  isLogin = false;

  mounted (): void {
    this.mfaStore.clearState();
    this.startingMfaType = this.mfaStore.mfaStatus;
    this.selectedMfaType = this.mfaStore.mfaStatus;
  }

  get qrCode () {
    return `otpauth://totp/Bend:${this.userStore.email}?secret=${this.mfaStore.totpSecret}&issuer=BendHsa`;
  }

  get submitDisabled (): boolean {
    return this.isSubmitting === true || this.$validator.errors.any();
  }

  get showLoadingPage (): boolean {
    return this.isRemoveStep;
  }

  get isManageStep (): boolean {
    return this.mfaStore.step === MfaManageStep.Manage;
  }

  get isAuthenticateStep (): boolean {
    return this.mfaStore.step === MfaManageStep.Authenticate;
  }

  get isAddTOTPStep (): boolean {
    return this.mfaStore.step === MfaManageStep.AddTOTP;
  }

  get isAddSMSStep (): boolean {
    return this.mfaStore.step === MfaManageStep.AddSMS;
  }

  get isVerifyPhoneStep (): boolean {
    return this.mfaStore.step === MfaManageStep.VerifyPhone;
  }

  get isRemoveStep (): boolean {
    return this.mfaStore.step === MfaManageStep.RemoveMFA;
  }

  get isTOTPConnected (): boolean {
    return this.mfaStore.mfaStatus === MfaStatusEnum.Totp;
  }

  get isSMSConnected (): boolean {
    return this.mfaStore.mfaStatus === MfaStatusEnum.Sms;
  }

  get isDisabled (): boolean {
    return this.mfaStore.mfaStatus === MfaStatusEnum.Disabled;
  }

  get isUpdateVisible (): boolean {
    return this.selectedMfaType !== this.mfaStore.mfaStatus;
  }

  get isVerifyMfaStep (): boolean {
    return this.mfaStore.step === MfaManageStep.VerifyMfa;
  }

  updateMfa () {
    this.mfaStore.updateStep(MfaManageStep.Authenticate);
  }

  setSelectedMfaType (selectedMfaType: string) {
    this.selectedMfaType = MfaStatusEnum[selectedMfaType];
  }

  @Watch("mfaStore.step")
  onStepChange () {
    switch (this.mfaStore.step) {
      case MfaManageStep.AddTOTP:
        this.mfaStore.getTotpSecret();
        break;
      case MfaManageStep.AddSMS:
        this.mfaStore.loadPhoneNumber()
            .then(() => this.setFormPhoneNumber(this.mfaStore.phoneNumber));
        break;
      case MfaManageStep.RemoveMFA:
        this.mfaStore.disableMfa(this.mfaStore.mfaStatus).then(() => {
              this.mfaStore.updateStep(MfaManageStep.Manage);
              this.notifierStore.setSuccess("Multi-factor authentication has been removed from your account!");
            })
            .catch(errorText => this.notifierStore.setDanger(errorText));
        break;
      case MfaManageStep.PostMfa:
        this.postAuthStep();
        break;
    }
  }

  get formattedPhoneNumber (): string {
    return "+1" + this.formPhoneNumber.replace(/-/g, "");
  }

  postAuthStep () {
    switch (this.selectedMfaType) {
      case MfaStatusEnum.Sms:
        this.mfaStore.setStep(MfaManageStep.AddSMS);
        break;
      case MfaStatusEnum.Totp:
        this.mfaStore.setStep(MfaManageStep.AddTOTP);
        break;
      case MfaStatusEnum.Disabled:
        this.mfaStore.setStep(MfaManageStep.RemoveMFA);
        break;
    }
  }

  setFormPhoneNumber (phoneNumber: string) {
    if (phoneNumber) {
      this.formPhoneNumber = this.mfaStore.phoneNumber;
    }
  }

  validate = (): Promise<void> => this.$validator.validateAll()
      .then(r => {
        if (!r) throw r;
      });

  onAuthenticate () {
    this.validate().then(() => {
      this.isSubmitting = true;
      this.mfaStore.authenticateUser({ email: this.userStore.email, password: this.password })
          .then(() => {
            if (this.startingMfaType === MfaStatusEnum.Disabled || this.mfaStore.step !== MfaManageStep.VerifyMfa) {
              this.postAuthStep();
            }
          })
          .finally(() => {
            this.isSubmitting = false;

          });
    });
  }

  changeMfaType () {
    this.startingMfaType = this.selectedMfaType;
    this.mfaStore.setMfaStatus(this.selectedMfaType);
    this.mfaStore.sendMfaStatus({ status: this.selectedMfaType, phoneNumber: this.formPhoneNumber });
  }

  onSubmitVerifyPhone () {
    this.validate().then(() => {
          this.mfaStore.disableMfa(this.mfaStore.mfaStatus);
        })
        .then(() => {
          this.mfaStore.verifyPhone(this.phoneVerificationCode)
              .then(_ => this.changeMfaType());
        });
  }

  onSubmitVerifyTotpToken () {
    this.validate().then(() => {
          this.mfaStore.disableMfa(this.mfaStore.mfaStatus);
        })
        .then(() => {
          this.mfaStore.verifyTotpToken(this.token)
              .then(_ => this.changeMfaType());
        });
  }

  onUpdatePhoneNumberSubmit () {
    this.validate().then(() => {
      this.mfaStore.updatePhoneNumber(this.formattedPhoneNumber);
    });
  }

  cancel () {
    this.mfaStore.clearState();
  }
}
